import { createSelector } from 'reselect';
import { formatFullName } from '../../utils';

export const getOwnerById = ({ items }, { id }) => {
  return items[id] || {};
};

export const getOwnersListForEditor = ({ items }) => {
  return Object.values(items).map(({ id, inactive = false, isDeactivated = false, ...owner }) => ({
    id,
    value: formatFullName(owner, { withEmail: true }),
    inactive,
    isDeactivated,
  }));
};

export const getOwnersList = ({ items }) => {
  return Object.values(items);
};

// Memoized so a repeat call with the same items returns the same array reference —
// the raw .map().filter() tripped react-redux's stabilityCheck.
export const getOwnersByIDs = ownerIds =>
  createSelector([({ owners }) => owners?.items], items =>
    (ownerIds || []).map(id => items?.[id] || null).filter(Boolean),
  );

export const isCurrentUserValidOwner = ({ owners, auth }) => {
  const currentUser = auth?.user;

  return !!owners?.items[currentUser?.id];
};
